import React, { useEffect, useState } from "react";
import { Helmet as RHelmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { DEFAULT_LANG, getRoutes, SUPPORTED_LANGS } from "../Localization/routesLocalized";
import i18next from "i18next";
import { useTxt } from "../Routes/Localized";
import { generateUID } from "../Firebase/firebase_init";

const blocked_paths = ['/article', '/cars'];

function getPathId(pathInit) {
  const path = String(pathInit || "/");

  const finalHData = getRoutes();
  for (let i = 0; i < finalHData.length; i++) {
    const helmetPath = finalHData[i].path;
    if ((helmetPath === path || path.startsWith(helmetPath)) && finalHData[i].helmetId) {
      return finalHData[i].helmetId;
    }
  }

  return 1;
}

const LANG_REGEX = new RegExp(`^/(${SUPPORTED_LANGS.join("|")})(?=/|$)`);

function getPathWithoutLang(pathname) {
  return String(pathname.replace(LANG_REGEX, ""));
}

export function addLanguageTags(pathname = "") {
  const cleanPath = getPathWithoutLang(pathname);

  return [
    ...SUPPORTED_LANGS.map((lang) => (
      <link
        key={lang}
        rel="alternate"
        href={`https://carskaut.com/${lang}${cleanPath}`}
        hreflang={lang}
      />
    )),
    <link
      key="x-default"
      rel="alternate"
      href={`https://carskaut.com/${DEFAULT_LANG}${cleanPath}`}
      hreflang="x-default"
    />
  ];
}

export default function Helmet({ children }) {
  const txt = useTxt();
  const location = useLocation();
  const pathname = location.pathname;
  const cleanPath = getPathWithoutLang(pathname);

  const dontHelmet = blocked_paths.some(prefix => prefix === cleanPath || cleanPath.startsWith(prefix));
  if (dontHelmet) {
    return children;
  }

  const id_pre = getPathId(cleanPath.replace("/", ""));
  const id = String(id_pre || 1).padStart(2, "0");
  const title = txt(`default:9990${id}`);
  const description = txt(`default:9980${id}`);

  return (
    <>
      <RHelmet key={location.pathname}>
        <html lang={i18next.language} />
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        {addLanguageTags(pathname)}
      </RHelmet>
      {children}
    </>
  );
}
